import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exit",
  "use": "icon-exit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-exit\"><g fill=\"currentColor\"><path d=\"M2 8a1 1 0 1 1-2 0V4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-4a1 1 0 0 1 2 0v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4z\" /><path d=\"M15.612 11l-4.317-4.29a1 1 0 1 1 1.41-1.42l6.555 6.516-6.553 6.553a1 1 0 0 1-1.414-1.414L15.238 13H1a1 1 0 0 1 0-2h14.612z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol